<template>
  <div :class="$style.header">
    <div :class="$style.headerLeft">
      <MobileIconButton v-if="showHomeButton"
                        :class="$style.headerBtn"
                        symbol="nav-home-icon"
                        icon-size="18 16"
                        @click="goToHome()" />

      <MobileIconButton v-else-if="showBackButton"
                        :class="$style.headerBtn"
                        symbol="arrow-back"
                        icon-size="15 14"
                        @click="goBack()" />
      <MobileIconButton v-else-if="showCloseButton"
                        :class="$style.headerBtn"
                        symbol="close-icon"
                        icon-size="15"
                        @click="goToRout()" />
      <MobileIconButton v-else-if="showCollapseButton"
                        :class="$style.headerBtn"
                        symbol="chevron-down"
                        icon-size="15"
                        @click="collapse()" />

      <MobileIconButton v-else-if="showMenuButton"
                        :class="$style.headerBtn"
                        symbol="mobile-menu-icon"
                        icon-size="16"
                        @click="goToMenu()" />
    </div>
    <div :class="$style.headerCenter">
      <slot />
    </div>
    <div :class="$style.headerRight">
      <MobileIconButton v-if="showConfirmBtn"
                        :class="$style.headerBtn"
                        :disabled="disabledConfirmBtn"
                        symbol="mobile-check-icon"
                        icon-size="18 14"
                        @click="confirmed()" />
      <MobileCartButton v-if="showCart"
                        :disabled="cartDisabled"
                        @click="toggleCart"/>

      <div v-if="showLogoutBtn"
           :class="$style.headerLogoutWrapper">
        <span :class="$style.headerTooltip">Log Out</span>
        <MobileIconButton
          :class="$style.headerBtn"
          symbol="mobile-logout-icon"
          icon-size="16"
          @click="logout()" />
      </div>

    </div>
  </div>
</template>

<script>
import Component from 'vue-class-component';
import Vue from 'vue';
import MobileCartButton from '@/apps/mobile/components/MobileCartButton';
import MobileIconButton from '@/apps/mobile/components/MobileIconButton';
import { Action } from 'vuex-class';
import { CART_EXPAND } from '@/apps/cart/store/types';
import { AUTH_LOGOUT } from '@/apps/auth/store/types';

/**
 * Mobile header for pages.
 */
@Component({
  components: {
    MobileCartButton,
    MobileIconButton,
  },
  props: {
    /**
     * Navigation action.
     * Set left icon view and action.
     */
    navAction: {
      type:     String,
      required: false,
      default:  'back',
      /**
       * Validator.
       */
      validator(value) {
        return [ 'back', 'home', 'close', 'collapse', 'menu' ].indexOf(value) !== -1;
      },
    },
    /**
     * Close action router link.
     */
    closeTo: {
      type:     [ Object, String ],
      required: false,
      default:  () => ({ name: 'mobile-main' }),
    },
    showCart: {
      type:     Boolean,
      default:  false,
      required: false,
    },
    cartDisabled: {
      type:     Boolean,
      default:  false,
      required: false,
    },
    showConfirmBtn: {
      type:     Boolean,
      default:  false,
      required: false,
    },
    disabledConfirmBtn: {
      type:     Boolean,
      default:  false,
      required: false,
    },
    showLogoutBtn: {
      type:     Boolean,
      default:  false,
      required: false,
    },
  },
})
export default class MobileHeader extends Vue {
  @Action(CART_EXPAND) cartExpand;
  @Action(AUTH_LOGOUT) logoutUser;

  get showHomeButton() {
    return this.navAction === 'home';
  }

  get showBackButton() {
    return this.navAction === 'back';
  }

  get showCloseButton() {
    return this.navAction === 'close';
  }

  get showCollapseButton() {
    return this.navAction === 'collapse';
  }

  get showMenuButton() {
    return this.navAction === 'menu';
  }

  /**
   * Go to home rout.
   */
  goToHome() {
    this.$router.push({ name: 'mobile-main' });
  }

  /**
   * Co back.
   */
  goBack() {
    this.$router.go(-1);
  }

  /**
   * Go to rout.
   */
  goToRout() {
    this.$router.push(this.closeTo);
  }

  /**
   * Go to menu.
   */
  goToMenu() {
    this.$router.push({ name: 'menu' });
  }

  /**
   * Collapse action.
   */
  collapse() {
    this.$emit('collapse');
  }

  /**
   * Toggle cart view.
   */
  toggleCart() {
    this.cartExpand();
  }

  /**
   * Confirmed event.
   */
  confirmed() {
    this.$emit('confirmed');
  }

  /**
   * Logout.
   */
  logout() {
    this.logoutUser();
    this.$router.push({ name: 'mobile-main' });
  }
}
</script>

<style lang="scss" module>
@import "@/style/helpers.scss";
@import "@/style/variables.scss";

.header {
  min-height: $mobile-header-min-height;
  width: 100%;
  background: $white;
  box-shadow: 0 1px 2px 0 $mobile-header-shadow-color;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 $mobile-content-side-padding;

  &Left,
  &Right {
    flex: 1 1 20%;
  }

  &Right {
    direction: rtl;
  }

  &Center {
    color: $black;
    font-family: $main-font-family;
    font-icon-size: 1rem;
    font-weight: bold;
    letter-spacing: -0.08px;
    line-height: 1.2;
    text-align: center;
    text-transform: uppercase;
  }

  &Btn {
    margin: 0;
  }

  &LogoutWrapper {
    display: flex;
    align-items: center;
    gap: 1px;
  }

  &Tooltip {
    order: 1;
    color: $black;
    font-family: $main-font-family;
    font-size: 0.8rem;
  }
}

</style>



// WEBPACK FOOTER //
// src/apps/mobile/components/MobileHeader.vue